// extracted by mini-css-extract-plugin
module.exports = {"order":"Order_order__1o20f","button":"Order_button__2iKAz","active":"Order_active__zdPQD"};